import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ColdStartContainer, MainContainer } from "./ColdStartPreviewStyles";

import DrawingArea from "./DrawingArea/DrawingArea";
import Header from "./Header/Header";
import ColdStartLoader from "./ColdStartLoader/ColdStartLoader";
import ColdStartButtons from "./ColdStartButtons/ColdStartButtons";
import ColdStartTutorial from "./ColdStartTutorial/ColdStartTutorial";
import { useDetectedPatternData } from "../DetectionPreviewGrid/DetectedPatterns/hooks/useDetectedPatternData";
import { setGridDisplay } from "../../../redux/slices/display";

function ColdStartPreview() {
  // Redux dispatch function
  const dispatch = useDispatch();

  // Select from redux store
  const training = useSelector(({ models }) => models.training);
  const fetchCompleted = useSelector(
    ({ detectedPatterns }) => detectedPatterns.fetchCompleted
  );
  const patternData = useDetectedPatternData();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // useEffect hooks
  useEffect(() => {
    if (training) setLoading(true);
  }, [training]);

  useEffect(() => {
    if (patternData.length > 1 || fetchCompleted) {
      dispatch(setGridDisplay());
    }
  }, [patternData, fetchCompleted, dispatch]);

  return (
    <Fragment>
      {!loading && <ColdStartTutorial />}
      <ColdStartContainer>
        {loading ? (
          <ColdStartLoader />
        ) : (
          <Fragment>
            <Header />
            <MainContainer>
              <DrawingArea />
            </MainContainer>
            <ColdStartButtons />
          </Fragment>
        )}
      </ColdStartContainer>
    </Fragment>
  );
}
export default ColdStartPreview;
